module.exports = __webpack_public_path__ + "static/media/8OLA7.766493d0.jpg";